import { useEffect, useState } from "react";
import { PhotoThumb } from "@/components/scan/Scan";
import { api } from "@/lib/api";

const LABEL = { pending: "Pending review", rejected: "Rejected", approved: "Approved" };
const TONE = { pending: "bg-amber-100 text-amber-900", rejected: "bg-rose-100 text-rose-800", approved: "bg-emerald-100 text-emerald-800" };

export function MyScans() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/scans/mine").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="surface mb-5 overflow-hidden fade-up" data-testid="my-scans">
      <div className="px-4 pt-3 pb-1 eyebrow">Scanned bills & receipts</div>
      <ul className="divide-y divide-border">
        {items.map((s) => (
          <li key={s.id} className="flex items-center gap-3 px-4 py-3" data-testid={`my-scan-${s.id}`}>
            <PhotoThumb photoId={s.photo_id} size="h-11 w-11" testId={`my-scan-photo-${s.id}`} />
            <div className="min-w-0 flex-1 text-sm">
              <div className="font-semibold truncate">{s.fields?.vendor || "Scan"}{s.fields?.amount ? ` · $${s.fields.amount}` : ""}</div>
              <div className="text-xs text-muted-foreground">{new Date(s.created_at).toLocaleDateString("en-US", { timeZone: "America/Nassau", month: "short", day: "numeric" })}</div>
            </div>
            <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${TONE[s.status]}`} data-testid={`my-scan-status-${s.id}`}>{LABEL[s.status]}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
